import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";

import { TimeZoneAbbreviations } from "./tzData";

interface ParseDateStringArgs {
  timeString?: string;
  format?: string;
  timezone?: keyof typeof TimeZoneAbbreviations;
  showAbbreviation?: boolean;
  userTZ?: string;
}

const DEFAULT_FORMAT = "DD MMM YYYY hh:mm A";

export const ParseDateString = ({
  timeString,
  format,
  timezone,
  showAbbreviation = true,
  userTZ
}: ParseDateStringArgs): string => {
  const momentInstance: moment.Moment = timeString
    ? moment(timeString)
    : moment();
  if (momentInstance.isValid()) {
    const confirmedFormat = format || DEFAULT_FORMAT;
    const confirmedTimeZone = timezone || userTZ;

    if (confirmedTimeZone) {
      if (showAbbreviation) {
        const abbreviation =
          TimeZoneAbbreviations[
            confirmedTimeZone as keyof typeof TimeZoneAbbreviations
          ];

        if (abbreviation) {
          return (
            momentInstance.tz(confirmedTimeZone!).format(confirmedFormat) +
            " " +
            abbreviation
          );
        } else {
          return (
            momentInstance.tz(confirmedTimeZone!).format(confirmedFormat) +
            " " +
            momentInstance.tz(confirmedTimeZone!).format("z")
          );
        }
      }
      return momentInstance.tz(confirmedTimeZone!).format(confirmedFormat);
    } else return momentInstance.tz("UTC").utc().format(confirmedFormat);
  } else return "Invalid Date";
};
